module.exports = __webpack_public_path__ + "src/images/measurements/hipCurve.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/measurements/hipCurve.jpg
// module id = 1149
// module chunks = 0